"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonStyle = exports.nineDotMenuImage = exports.nineDotMenuItem = exports.productLabel = exports.label = exports.subHeader = exports.mainHeader = exports.dropdownStyle = void 0;
var dropdownStyle = {
  maxWidth: '300px',
  margin: '0 auto',
  marginBottom: '20px',
  lineHeight: '12px'
};
exports.dropdownStyle = dropdownStyle;
var mainHeader = {
  fontFamily: "'Proxima Nova',sans-serif",
  fontSize: '30px',
  fontWeight: '100',
  textAlign: 'center'
};
exports.mainHeader = mainHeader;
var subHeader = {
  fontFamily: "'Proxima Nova',sans-serif",
  fontSize: '20px',
  fontWeight: '400',
  textAlign: 'center'
};
exports.subHeader = subHeader;
var label = {
  fontWeight: '600',
  justifyContent: 'center',
  color: '#0f849e',
  fontSize: '18px',
  textAlign: 'center'
};
exports.label = label;
var productLabel = {
  fontSize: '12px'
};
exports.productLabel = productLabel;
var nineDotMenuItem = {
  width: '50px',
  height: '50px'
};
exports.nineDotMenuItem = nineDotMenuItem;
var nineDotMenuImage = {
  width: '29px',
  height: '29px'
};
exports.nineDotMenuImage = nineDotMenuImage;
var buttonStyle = {
  margin: '0 auto',
  display: 'block'
};
exports.buttonStyle = buttonStyle;